<script lang="ts">

    import { redirectTo, storeCurRoute } from "../scripts/router1";
    import { idPageHome } from "../scripts/router2";
    import { storeLanguage, lang_fr, app_version } from "../scripts/store";

    /**
     * clicLogo
     */
    function clicLogo() {
        if ($storeCurRoute == idPageHome) {
            window.scrollTo({top: 0, behavior: 'smooth'});
        } else {
            redirectTo(idPageHome);
        }
    }

</script>

<style lang="scss">
	.footer {
		text-align: center;
		margin: 0 auto;
		background-color: $color_white;
        color: $color_white;
        &__top {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            width: 100%;
            height: 300px;
            background-image: url("../assets/images/footer-top.png");
            background-size: cover;
			background-repeat: no-repeat;
        }
        &__bottom {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: $color_white;
            height: 75px;
            color: $color_black;
            &__img {
                padding: 0 0 0 4px;
                height: 15px;
            }
        }
        &__logo {
            margin: 0 0 0 32px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            &__img {
                cursor: pointer;
                height: 50px;
            }
        }
        &__icon {
            width: 20px;
            height: 20px;
            background-size: cover;
			background-repeat: no-repeat;
            transition: all 1s;
            cursor: pointer;
            padding: 8px 8px 8px 8px;
        }
        &__twitter {
            width: 6px;
            height: 6px;
            background-image: url("../assets/images/logo-twitter-x-blanc.png");
            &:hover {
                background-image: url("../assets/images/logo-twitter-x-orange.png");
            }
        }
        &__linkedin {
            background-image: url("../assets/images/logo-linkedin-blanc.png");
            &:hover {
                background-image: url("../assets/images/logo-linkedin-orange.png");
            }
        }
        &__youtube {
            width: 15px;
            height: 15px;
            background-image: url("../assets/images/logo-youtube-blanc.png");
            &:hover {
                background-image: url("../assets/images/logo-youtube-orange.png");
            }
        }
        &__newsletter {
            width: 15px;
            height: 15px;
            background-image: url("../assets/images/newsletter.png");
            &:hover {
                background-image: url("../assets/images/newsletter_hover.png");
            }
        }
        &__contact {
            margin: 0 0 0 32px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            &__title {
                font-weight: bold;
                font-size: 20px;
            }
        }
        &__follow {
            margin: 0 0 0 32px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            &__title {
                font-weight: bold;
                font-size: 20px;
            }
            &__social {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
            }
        }
        &__version {
            font-size: xx-small;
            padding: 4px 0 0 0;
        }
	}

    @include large {
        .footer {
            &__top {
                flex-direction: row;
            }
            &__logo {
                margin: 110px 0 0 0;
            }
            &__contact {
                margin: 110px 0 0 0;
            }
            &__follow {
                margin: 110px 0 0 0;
            }
        }

    }

</style>

<div class="footer">
	<div class="footer__top">
        <div class="footer__logo" on:click={() => clicLogo()} on:keydown={() => clicLogo()}>
            <img class="footer__logo__img" src="../assets/images/logo.png" alt="logo">
        </div>
        <div class="footer__contact">
            <div class="footer__contact__title">
                {#if ($storeLanguage == $lang_fr)}
                Ecrivez-nous
                {:else}
                Write us
                {/if}
            </div>
            contact@collectif-api-thinking.com
        </div>
        <div class="footer__contact">
            <div class="footer__contact__title">
                {#if ($storeLanguage == $lang_fr)}
                Abonnez-vous à la newsletter
                {:else}
                Subscribe to the newsletter
                {/if}
            </div>
            <a href="mailto:contact@collectif-api-thinking.com?subject=Demande d'abonnement à la newsletter du Collectif" target="_blank">
                <div class="footer__icon footer__newsletter"></div> 
            </a>
        </div>
        <div class="footer__follow">
            <div class="footer__follow__title">
                {#if ($storeLanguage == $lang_fr)}
                Suivez-nous
                {:else}
                Follow us
                {/if}
            </div>
            <div class="footer__follow__social">
                <a href="https://www.linkedin.com/company/collectif-api-thinking/" target="_blank">
                    <div class="footer__icon footer__linkedin"></div>    
                </a>
                <a href="https://www.youtube.com/channel/UCfYzLMGcOKMOu6d2hDuhD2w" target="_blank">
                    <div class="footer__icon footer__youtube"></div>    
                </a>
            </div>
        </div>
    </div>
    <div class="footer__bottom">
        <span>
            {#if ($storeLanguage == $lang_fr)}
            Site cuisiné à base d'APIs par
            {:else}
            Website cooked with API by
            {/if}
            <a href="https://kortefa.net" target="_blank">
                <img  class="footer__bottom__img" src="../assets/images/kortefa.svg" alt="kortefa" title="körtefa">
            </a>    
        </span>
        <div class="footer__version">
            {$app_version.version}
        </div>
    </div>
</div>
